import { moduleItem, wardrobeData, wardrobeModule } from '@/Interfaces/common';
import { useStoreData } from '@/Store/storeData';
import { toJSON } from '@/lib/createModule';

export const updatePresetData = (wardrobe: wardrobeData) => {
    console.log(wardrobe);
    let widthFix = false;
    const version = wardrobe.version;
    if (!version) {
        console.warn('Старая версия пресета, без номера версии');
        widthFix = true;
    } else {
        console.log('Версия пресета: ', version);
        const [ major, minor, patch ] = version.split('.');
        if (major <= 1 && minor <= 4 && patch < 8) {
            widthFix = true;
        }
    }


    if (widthFix) {
        console.log('Фикс изменения ширины модулей 600 = 607, 900 = 902');
        wardrobe.shelves.sort((prev, next)=>{
            return prev.position[0] - next.position[0];
        });

        const length = wardrobe.shelves.length;
        let currentModuleId: undefined | string;
        wardrobe.shelves.forEach((shelf: moduleItem, index) => {
            if (shelf.width === 0.6 &&
                shelf.rackModuleUUID !== currentModuleId
            ) {
                currentModuleId = shelf.rackModuleUUID;
                for (let i = index; i < length; i++) {
                    const nextShelf = wardrobe.shelves[i];
                    if (Math.abs(nextShelf.position[0] - shelf.position[0]) > 0.445 &&
                        shelf.side === nextShelf.side
                    ) {
                        nextShelf.position[0] += 0.007;
                    }

                }
            }
            if (shelf.width === 0.9 &&
                shelf.rackModuleUUID !== currentModuleId) {
                for (let i = index; i < length; i++) {
                    const nextShelf = wardrobe.shelves[i];
                    if (Math.abs(nextShelf.position[0] - shelf.position[0]) > 0.445 &&
                        shelf.side === nextShelf.side
                    ) {
                        nextShelf.position[0] += 0.002;
                    }
                }
            }

        });
    }


    wardrobe.shelves.forEach((shelf)=>{
        // shelf.templates.basket.id
        const newShelfBracketLeft = useStoreData().getItemsByIdArr([ shelf.templates.shelfBracketLeft?.id ])[0];

        if (newShelfBracketLeft && shelf.templates.shelfBracketLeft) {
            shelf.templates.shelfBracketLeft.rotation = toJSON(newShelfBracketLeft.rotation);

        }
        const newShelfBracketRight = useStoreData().getItemsByIdArr([ shelf.templates.shelfBracketRight?.id ])[0];
        if (newShelfBracketRight && shelf.templates.shelfBracketRight) {
            shelf.templates.shelfBracketRight.rotation = toJSON(newShelfBracketRight.rotation);
        }
    });
};
